import { css } from "@compiled/react";

import { ConfluenceOverlayTemplate } from "@/components/signup/layouts";
import SiteActivation, {
    JoinableSites
} from "@/components/signup/site-activation";
import {
    Headings,
    JoinableSitesText,
    WelcomeBackText
} from "../../../components";

export const CurrentProductJoinableUser = () => {
    return (
        <ConfluenceOverlayTemplate size="sm">
            <div css={containerCss}>
                <Headings
                    main={<WelcomeBackText />}
                    sub={<JoinableSitesText />}
                />
                <SiteActivation
                    CurrentProductJoinableUser={<JoinableSites />}
                    useContactExpandCohortLogic={true}
                />
            </div>
        </ConfluenceOverlayTemplate>
    );
};

const containerCss = css({
    display: "grid",
    gap: "10px"
});
